const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/sections/Versicherung.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { VersicherungField } from 'App/components/eCheckin/components/fields/metakat/VersicherungField';
import textMap from '../translations';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { VersicherungsdeckungField } from 'App/components/eCheckin/components/fields/metakat/VersicherungsdeckungField';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { VersicherungsNameField } from './components/VersicherungsNameField';

export const Versicherung = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_BEHANDLUNGSGRUND = createFieldPath(path, 'behandlungsgrund');
    const PATH_KLASSE = createFieldPath(path, 'klasse');
    const PATH_VERSICHERUNG = createFieldPath(path, 'versicherung');
    const PATH_VERSICHERUNGSNR = createFieldPath(path, 'PoliceNr');

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <VersicherungField label={textMap.behandlungsgrund} path={PATH_BEHANDLUNGSGRUND} required={true} />
            <VersicherungsdeckungField label={textMap.klasse} path={PATH_KLASSE} required={true} />
            <VersicherungsNameField label={textMap.versicherungName} path={PATH_VERSICHERUNG} required={true} />
            <CIS4mTextField label={textMap.policyNr} path={PATH_VERSICHERUNGSNR} />
        </ECheckinSection>
    );
});

Versicherung.displayName = 'Versicherung';

export default Versicherung;
